/*
 * Laptop weights, in kilograms, keyed by a fragment of the model name.
 *
 * WHY THIS FILE EXISTS
 * Every laptop variant in the store carries a flat 1.5 kg. That is the
 * per-category SHIPPING weight used to generate MyPost Business labels, not
 * the weight of the machine - an X1 Carbon and a 15" ProBook both read
 * 1.5 kg. It is deliberately left alone, because overwriting it would change
 * the shipping paperwork. Real weights live here instead.
 *
 * WHAT THE NUMBERS ARE
 * The published figure for the standard configuration of that model. Real
 * units vary by roughly 100g either way: a touchscreen panel is heavier than
 * a matte one, a 6-cell battery heavier than a 4-cell, and some lines
 * shipped several chassis options. Treat them as accurate to about a tenth
 * of a kilo, which is the precision the decision actually turns on - 1.2 kg
 * against 2.0 kg is a real difference, 1.24 against 1.26 is noise.
 *
 * HOW MATCHING WORKS
 * First match wins on a lowercased `contains`, so ORDER MATTERS: the more
 * specific pattern has to come first. "latitude 7390 2-in-1" is listed above
 * "latitude 7390", and "x1 carbon" above the general ThinkPad X entries.
 * A model that matches nothing returns no weight and the row is simply left
 * out, which is the right outcome - a guessed weight is worse than none.
 *
 * Detachables and tablets are the weight of the tablet on its own, without
 * the keyboard cover, and are flagged in the comments.
 *
 * COVERAGE was measured at 100% of in-stock laptops when last checked. If a
 * new family starts selling, add it here - put it in the right brand block,
 * above anything more general that would otherwise swallow it.
 */
window.VG_LAPTOP_WEIGHTS = [
  /* ---------------------------------------------------- Lenovo ThinkPad -- */
  ['x1 nano', 0.91],
  ['x1 carbon', 1.13],
  ['x1 yoga', 1.4],
  ['x1 extreme', 1.7],
  ['thinkpad p1', 1.7],
  ['thinkpad p53s', 1.7],
  ['thinkpad p50', 2.5],
  ['thinkpad p51', 2.5],
  ['thinkpad p52', 2.5],
  ['thinkpad p53', 2.5],

  ['x380 yoga', 1.4],
  ['x390 yoga', 1.4],
  ['x13 yoga', 1.4],
  ['thinkpad x13', 1.3],
  ['thinkpad x230', 1.34],
  ['thinkpad x240', 1.34],
  ['thinkpad x250', 1.32],
  ['thinkpad x260', 1.32],
  ['thinkpad x270', 1.32],
  ['thinkpad x280', 1.13],
  ['thinkpad x390', 1.29],
  ['thinkpad yoga 260', 1.3],
  ['lenovo x13 yoga', 1.4],

  ['t14s', 1.27],
  ['t15s', 1.7],
  ['t440s', 1.4],
  ['t450s', 1.4],
  ['t460s', 1.3],
  ['t470s', 1.32],
  ['t480s', 1.32],
  ['t490s', 1.27],
  ['thinkpad t14', 1.46],
  ['thinkpad t15', 1.75],
  ['thinkpad t450', 1.7],
  ['thinkpad t460', 1.7],
  ['thinkpad t470', 1.7],
  ['thinkpad t480', 1.75],
  ['thinkpad t490', 1.46],
  ['thinkpad t540', 2.4], /* 15.6" workstation-weight chassis */
  ['thinkpad t550', 1.87],
  ['thinkpad t570', 1.95],
  ['thinkpad t590', 1.75],

  ['l13 yoga', 1.5],
  ['thinkpad l13', 1.4],
  ['thinkpad l380', 1.46],
  ['thinkpad l390', 1.46],
  ['thinkpad l14', 1.6],
  ['thinkpad l15', 1.8],
  ['thinkpad l490', 1.6],
  ['thinkpad l590', 1.85],

  ['thinkpad e14', 1.7],
  ['thinkpad e15', 1.9],
  ['thinkpad e470', 1.8],
  ['thinkpad e480', 1.75],
  ['thinkpad e570', 2.2],
  ['thinkpad v15', 1.85],
  ['thinkpad v', 1.85],

  /* ------------------------------------------- Lenovo ThinkBook / IdeaPad -- */
  ['thinkbook 13s', 1.34],
  ['thinkbook 14 yoga', 1.5],
  ['thinkbook 14s yoga', 1.5],
  ['thinkbook 370 yoga', 1.5],
  ['thinkbook 14', 1.4],
  ['thinkbook 15', 1.7],
  ['ideapad yoga 7', 1.4],
  ['yoga c740', 1.4],
  ['yoga 910', 1.38],
  ['yoga 920', 1.4],
  ['yoga 530', 1.6],
  ['ideapad 3 14', 1.4],
  ['ideapad 3 15', 1.7],
  ['ideapad', 1.6],

  /* ----------------------------------------------------- Dell Latitude -- */
  ['latitude 7200', 0.85], /* detachable - tablet only, no keyboard */
  ['latitude 7210', 0.85], /* detachable - tablet only, no keyboard */
  ['latitude 7320 detachable', 0.78], /* tablet only, no keyboard */
  ['latitude 5290 2-in-1', 1.2], /* detachable - tablet only */
  ['latitude 7389', 1.45],
  ['latitude 7390 2-in-1', 1.42],
  ['latitude 7400 2-in-1', 1.49],
  ['latitude 7420 2-in-1', 1.49],
  ['latitude 9420', 1.4],
  ['latitude 9430', 1.4],
  ['latitude 7414', 2.6], /* rugged */

  ['latitude 7280', 1.18],
  ['latitude 7290', 1.18],
  ['latitude 7300', 1.22],
  ['latitude 7310', 1.21],
  ['latitude 7320', 1.19],
  ['latitude 7330', 1.16],
  ['latitude 7380', 1.28],
  ['latitude 7390', 1.28],
  ['latitude 7400', 1.36],
  ['latitude 7410', 1.43],
  ['latitude 7420', 1.27],
  ['latitude 7430', 1.28],
  ['latitude 7440', 1.36],
  ['latitude 7480', 1.48],
  ['latitude 7489', 1.45],
  ['latitude 7490', 1.48],
  ['latitude 7520', 1.59],
  ['latitude 7530', 1.59],

  ['latitude e7240', 1.5],
  ['latitude e7250', 1.4],
  ['latitude e7270', 1.45],
  ['latitude e7440', 1.6],
  ['latitude e7450', 1.72],
  ['latitude e7470', 1.53],

  ['latitude 5280', 1.3],
  ['latitude 5290', 1.3],
  ['latitude 5300', 1.36],
  ['latitude 5310', 1.27],
  ['latitude 5320', 1.28],
  ['latitude 5330', 1.27],
  ['latitude 5340', 1.36],
  ['latitude 5400', 1.48],
  ['latitude 5401', 1.48],
  ['latitude 5410', 1.5],
  ['latitude 5411', 1.5],
  ['latitude 5420', 1.45],
  ['latitude 5421', 1.45],
  ['latitude 5430', 1.42],
  ['latitude 5440', 1.36],
  ['latitude 5470', 1.63],
  ['latitude 5480', 1.6],
  ['latitude 5490', 1.6],
  ['latitude 5500', 1.85],
  ['latitude 5510', 1.85],
  ['latitude 5511', 1.88],
  ['latitude 5520', 1.79],
  ['latitude 5530', 1.79],
  ['latitude 5540', 1.69],
  ['latitude 5580', 1.9],
  ['latitude 5590', 1.9],
  ['latitude e5470', 1.63],
  ['latitude e5480', 1.6],
  ['latitude e5570', 2.0],

  ['latitude 3310', 1.5],
  ['latitude 3320', 1.4],
  ['latitude 3330', 1.4],
  ['latitude 3390', 1.6],
  ['latitude 3410', 1.6],
  ['latitude 3420', 1.6],
  ['latitude 3490', 1.6],
  ['latitude 3500', 1.9],
  ['latitude 3510', 1.9],
  ['latitude 3520', 1.79],
  ['latitude 3590', 2.0],

  /* -------------------------------------------------------- Dell other -- */
  ['xps 15', 1.8],
  ['xps 13', 1.2],
  ['precision 7510', 3.0],
  ['precision 7520', 3.0],
  ['precision 7530', 2.9],
  ['precision 7540', 2.9],
  ['precision 5510', 1.8],
  ['precision 5520', 1.8],
  ['precision 5530', 1.8],
  ['precision 5540', 1.8],
  ['precision 5550', 1.84],
  ['precision 5560', 1.84],
  ['precision 5570', 1.86],
  ['precision 3480', 1.4],
  ['precision 3540', 1.9],
  ['precision 3541', 1.9],
  ['precision 3551', 1.9],
  ['precision 3560', 1.59],
  ['precision 3571', 1.85],

  ['inspiron 13', 1.5],
  ['inspiron 14', 1.6],
  ['inspiron 15', 1.8],
  ['inspiron 7370', 1.4],
  ['inspiron 7373', 1.45],
  ['inspiron 7386', 1.45],
  ['inspiron 7391', 1.4],
  ['inspiron 7586', 1.9],
  ['inspiron 5379', 1.7],
  ['inspiron 5481', 1.7],
  ['inspiron 5491', 1.7],
  ['inspiron 5480', 1.6],
  ['inspiron 5593', 1.83],
  ['inspiron 5559', 2.3],
  ['inspiron 3501', 1.83],
  ['inspiron', 1.8],

  ['vostro 5301', 1.2],
  ['vostro 5490', 1.5],
  ['vostro 5510', 1.6],
  ['vostro 5581', 1.9],
  ['vostro 7500', 1.9],
  ['vostro 3500', 1.78],
  ['vostro 3510', 1.78],
  ['vostro 3590', 1.99],

  /* --------------------------------------------------------------- HP -- */
  ['elite dragonfly', 0.99],
  ['elitebook 840 aero', 0.99],
  ['elitebook x360 1030', 1.28],
  ['elitebook x360 1040', 1.35],
  ['elitebook 1030', 1.28],
  ['elitebook 1040', 1.35],
  ['elitebook folio 1040', 1.43],
  ['elitebook x360 830', 1.35],
  ['elitebook 830', 1.33],
  ['elitebook 840', 1.48],
  ['elitebook 850', 1.78],
  ['elitebook 630', 1.37],
  ['elitebook 640', 1.37],

  ['probook x360 435', 1.49],
  ['probook 430', 1.49],
  ['probook 440', 1.38],
  ['probook 450', 1.98],
  ['probook 640', 1.48],
  ['probook 650', 1.95],

  ['zbook 14u', 1.48],
  ['zbook studio', 1.8],
  ['zbook 15', 2.6],

  ['spectre x360', 1.27],
  ['envy 13', 1.3],
  ['pavilion 15', 1.75],
  ['hp 250', 1.74],
  ['hp 15s', 1.69],

  /* ------------------------------------------------------------ Apple -- */
  ['macbook pro 16', 2.0],
  ['macbook pro 15', 1.83],
  ['macbook pro 13', 1.37],
  ['macbook pro', 1.4],
  ['macbook air', 1.29],

  /* -------------------------------------------------------- Microsoft -- */
  ['surface book', 1.53],
  ['surface laptop', 1.29],
  ['surface pro', 0.78], /* tablet only, no keyboard cover */

  /* ------------------------------------------------------------ other -- */
  ['portege x40', 1.25],
  ['portege x20', 1.1], /* 12.5" convertible */
  ['portege', 1.2], /* catches the rest of the Toshiba/Dynabook Portege line */
  ['dynabook', 1.25],
  ['summit b15', 1.6],
  ['acer spin 5', 1.2],
  ['asus f407', 1.5],
];